// HomeWeb.jsx
import {React, useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/homeWebStyles';
import { useLogScreen } from '../useLogScreen';
export default function HomeWeb() {
    const navigation = useNavigation();
    useLogScreen('HomePWA');

    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Home';
            }, 100);
        }
    }, []);
    
    const modules = [
        { icon: require('../assets/icons/home.png'), label: 'PRECIFICADOR', screen: 'DilWeb' },
        { icon: require('../assets/icons/avaliador-roxo.png'), label: 'SIMULADOR DE CRÉDITO IMOBILIÁRIO', screen: 'SimuladorDeCreditoWeb' },
        { icon: require('../assets/icons/planejador.png'), label: 'PLANEJADOR DE REDES SOCIAIS', screen: 'PlanejadorRedesWeb' },
        { icon: require('../assets/icons/query.png'), label: 'EMISSÃO DE CERTIDÕES', screen: 'AnaliseDeCertidoesWeb' },
        { icon: require('../assets/icons/play.png'), label: 'TRILHA DO CONHECIMENTO', screen: 'TrilhaDoConhecimentoWeb' },
        { icon: require('../assets/icons/foto_camera.png'), label: 'HOME STAGING', screen: 'CelerWeb' },
        { icon: require('../assets/icons/files.png'), label: 'GERADOR DE CONTRATOS', screen: 'GeradorDeContratosWeb' },
        { icon: require('../assets/icons/money.png'), label: 'PARCELAMENTO DE BOLETOS', screen: 'BoletoParceladoWeb', disabled: false },
        { icon: require('../assets/icons/sacola.png'), label: 'GERADOR DE ANÚNCIOS', screen: '/', disabled: true },
    ];

    return (
        <BaseWeb>
            {(userInfo) => (
                <ScrollView contentContainerStyle={styles.contentMinimal}>
                    <Text style={styles.welcomeMinimal}>
                        Bem-vindo(a), {userInfo?.nome_social || 'Corretor'}
                    </Text>

                    <View style={styles.gridMinimal}>
                        {modules.map((mod, idx) => (
                            <TouchableOpacity
                                key={idx}
                                disabled={mod.disabled}
                                onPress={() => {
                                    if (!mod.disabled) {
                                        navigation.navigate(mod.screen, {
                                            usuario_id: userInfo?.id,
                                            emailUser: userInfo?.email,
                                        });
                                    }
                                }}
                                style={[
                                    styles.cardMinimal,
                                    mod.disabled && styles.cardDisabled,
                                    Platform.OS === 'web' && !mod.disabled && { cursor: 'pointer' }
                                ]}
                            >
                                <Image source={mod.icon} style={styles.cardIconMinimal} />
                                <Text style={styles.cardLabelMinimal}>{mod.label}</Text>
                            </TouchableOpacity>
                        ))}
                    </View>
                </ScrollView>
            )}
        </BaseWeb>
    );
}
